import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import MedicalCardTextRow from './MedicalCardTextRow';
import MedicalCardHotlineSection from './MedicalCardHotlineSection';
import { MedicalCardHospMOPText, MedicalCardImage } from './styledComponents';
import { MedicalCardData } from '../interfaces';
import { HAS_HOSP_MOP, UNEXPIRED_HEALTH_CARD } from '../enums';

const MedicalCard = forwardRef<HTMLDivElement, MedicalCardData>(
  (
    {
      policyNumber,
      certNo,
      effectiveDate,
      expiryDate,
      hasHOSPMOP,
      serviceProvider,
      unexpiredHealthCard,
      serviceProviderHotline,
      generatedOn,
      name,
    },
    ref,
  ) => {
    const { t } = useTranslation();

    const showHospMOP = hasHOSPMOP === HAS_HOSP_MOP.Y;
    const showPeriod = unexpiredHealthCard === UNEXPIRED_HEALTH_CARD.N;
    const periodDate = effectiveDate + '-' + expiryDate;

    return (
      <MedicalCardImage imagePath={serviceProvider} ref={ref}>
        <MedicalCardTextRow title={t('membershipCardDetail.name')} text={name} />
        <MedicalCardTextRow title={t('membershipCardDetail.certNo')} text={certNo} />

        <MedicalCardTextRow title={t('membershipCardDetail.policyNo')} text={policyNumber} textShrink={showHospMOP} />
        {showHospMOP && <MedicalCardHospMOPText strong>{t('membershipCardDetail.hospMOP')}</MedicalCardHospMOPText>}

        {/* <MedicalCardTextRow title={t('membershipCardDetail.effDate')} text={effectiveDate} />
        {showExpDate && <MedicalCardTextRow title={t('membershipCardDetail.expDate')} text={expiryDate} />} */}
        {!showPeriod && <MedicalCardTextRow title={t('membershipCardDetail.effDate')} text={effectiveDate} />}
        {showPeriod && <MedicalCardTextRow title={t('membershipCardDetail.period')} text={periodDate} />}

        {serviceProviderHotline && (
          <MedicalCardHotlineSection generatedOn={generatedOn} serviceProviderHotline={serviceProviderHotline} />
        )}
      </MedicalCardImage>
    );
  },
);

MedicalCard.displayName = 'MedicalCard';
MedicalCard.propTypes = {
  policyNumber: PropTypes.string.isRequired,
  certNo: PropTypes.string.isRequired,
  effectiveDate: PropTypes.string.isRequired,
  expiryDate: PropTypes.string.isRequired,
  hasHOSPMOP: PropTypes.string.isRequired,
  serviceProvider: PropTypes.string.isRequired,
  unexpiredHealthCard: PropTypes.string.isRequired,
  serviceProviderHotline: PropTypes.string.isRequired,
  generatedOn: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

export default MedicalCard;
